import * as Yup from 'yup';

export const uuidSchema = Yup.string()
  .nullable(true)
  .notRequired()
  .matches(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/, {
    message: 'Must be a valid TUUID',
    excludeEmptyString: true,
  });

export const onlyText = Yup.string()
  .nullable(true)
  .notRequired()
  .matches(/^[A-Za-z]+$/, {
    message: 'Only letters are allowed',
    excludeEmptyString: true,
  });
